/**
 * Ürün çevirileri — sepet, detay sayfası vb. için ortak yardımcılar.
 */

export function getProductLangKey(i18nLanguage) {
  if (!i18nLanguage) return 'tr';
  if (i18nLanguage.startsWith('zh')) return 'zh-CN';
  return i18nLanguage.substring(0, 2).toLowerCase();
}

/** Ürün listesi API'si için lang parametresi (backend 2 harfli kod kullanır). */
export function getApiLangParam(i18nLanguage) {
  const key = getProductLangKey(i18nLanguage);
  if (key === 'zh-CN') return 'zh';
  return key;
}

function getTranslation(product, langKey) {
  if (!product?.translations || !langKey || langKey === 'tr') return null;
  const translations = product.translations;
  return translations[langKey] || (langKey === 'zh-CN' ? translations.zh : null) || null;
}

export function getLocalizedProductName(product, langKey) {
  if (!product?.name) return '';
  const translation = getTranslation(product, langKey);
  if (!translation) return product.name;
  return translation.title || translation.name || product.name;
}

export function applyProductTranslation(product, langKey) {
  if (!product) return product;
  const translation = getTranslation(product, langKey);
  if (!translation) return product;
  return {
    ...product,
    name: translation.title || translation.name || product.name,
    description: translation.description ?? product.description,
    variants: translation.variants ?? product.variants,
  };
}
